"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapOrForOption = void 0;
/**
 *  Return the result of _transformer_ with using _input_ as an argument for it if _input_ is `Some(T)`.
 *  Otherwise, return _defaultValue_.
 *
 *  Basically, this operation is a combination `map()` and `unwrapOr()`.
 */
function mapOrForOption(input, defaultValue, transformer) {
    if (!input.ok) {
        return defaultValue;
    }
    var result = transformer(input.val);
    return result;
}
exports.mapOrForOption = mapOrForOption;
